import { useState } from "react";
import emailjs from "@emailjs/browser";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_8ucdrxk",
        "template_stc1x4j",
        formData,
        "zKIcnao_nR-BFQXwW"
      )
      .then(
        () => {
          setSubmitted(true);
          setFormData({ name: "", email: "", message: "" });
        },
        (error) => {
          alert("Failed to send message 😢");
          console.error(error);
        }
      );
  };

  return (
    // ✅ IMPORTANT: id added for anchor navigation
    <section
      id="contact"
      className="min-h-screen py-20 px-4 bg-black text-white flex justify-center items-center"
    >
      <div className="w-full max-w-lg">
        <h2 className="text-4xl font-bold mb-8 text-center bg-clip-text text-transparent bg-gradient-to-r from-green-400 to-blue-500">
          Contact Me
        </h2>

        {submitted && (
          <div className="mb-4 p-4 bg-green-500 text-black rounded-lg text-center">
            Message sent successfully!
          </div>
        )}

        <form
          onSubmit={handleSubmit}
          className="bg-gray-900 p-6 rounded-xl shadow-lg space-y-4"
        >
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full p-3 rounded-lg bg-black border border-gray-700"
          />

          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full p-3 rounded-lg bg-black border border-gray-700"
          />

          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
            rows="5"
            required
            className="w-full p-3 rounded-lg bg-black border border-gray-700"
          ></textarea>

          <button
            type="submit"
            className="w-full py-3 bg-green-400 hover:bg-green-500 rounded-lg font-semibold transition"
          >
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
}
